export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20cozy%20dark%20living%20room%20with%20warm%20ambient%20lighting%2C%20comfortable%20viewing%20experience%2C%20premium%20home%20theater%20aesthetic%2C%20no%20text%20overlay%2C%20atmospheric%20mood&width=700&height=500&seq=about-01&orientation=landscape"
                alt="极速影视平台介绍"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              关于极速影视
            </h2>
            <div className="space-y-3 text-sm text-foreground-400 leading-relaxed">
              <p>
                极速影视成立于2020年，是国内领先的高清在线影视播放平台。我们致力于为全国用户提供极速不缓冲、流畅不卡顿的观影体验，让每一位追剧爱好者都能享受到秒开即播的畅快感受。
              </p>
              <p>
                平台采用自研智能CDN加速技术，覆盖全国300+节点，确保无论身处何地都能获得丝滑的高清在线观看体验。目前站内已收录超过三万余部影视作品，涵盖国产剧、日韩剧、欧美剧、动漫、综艺、纪录片、电影、少儿等全品类内容。
              </p>
              <p>
                我们坚持「免费看全集」的核心理念，用户无需付费即可畅享海量正版影视资源。每日内容团队精选300+新片同步更新，让你永远不会错过任何一部好剧。极速高清不卡，秒开即播随心追——这不仅仅是一句口号，更是我们对每一位用户的承诺。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 px-4 py-2 bg-accent-500/10 rounded-lg border border-accent-500/20">
                <i className="ri-shield-check-line text-accent-500"></i>
                <span className="text-xs text-foreground-300 whitespace-nowrap">内容安全审核</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-accent-500/10 rounded-lg border border-accent-500/20">
                <i className="ri-cloud-line text-accent-500"></i>
                <span className="text-xs text-foreground-300 whitespace-nowrap">智能CDN加速</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-accent-500/10 rounded-lg border border-accent-500/20">
                <i className="ri-4k-line text-accent-500"></i>
                <span className="text-xs text-foreground-300 whitespace-nowrap">超清4K画质</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}